import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { configError } from './lib/supabase'

const root = ReactDOM.createRoot(document.getElementById('root'))

if (configError) {
  root.render(
    <div style={{ fontFamily: 'system-ui, sans-serif', maxWidth: 480, margin: '15vh auto', padding: 16, lineHeight: 1.5 }}>
      <h1 style={{ fontSize: 20 }}>Jackie's app could not start</h1>
      <p>{configError}</p>
    </div>
  )
} else {
  root.render(<React.StrictMode><App /></React.StrictMode>)
}
